// 發現線上已經換版就自己重新整理，不必等使用者記得按強制重新整理。
//
// 比對的是「打包時烘焙進來的 buildNo」與「伺服器上即時的 /version.json」（scripts/gen-version.js），
// 和 /version 頁面同一套。手機分頁可以開著好幾天、切回來是從記憶體還原，
// 舊的 JS 一直在跑，下架的按鈕也就一直還在。
//
// 什麼時候重新整理：
//   - 剛載入、或從背景切回來時發現舊了 → 立刻整理（這時畫面上沒有正在做的事）
//   - 用著用著背景檢查發現舊了 → 不打斷，等下一次換頁時改成整頁載入新網址
//     （會員中心填到一半的表單不會突然被洗掉）
//
// 防無限迴圈：CDN 或代理若還吐舊的 HTML，整理完拿到的仍是舊版，
// 因此同一個新版本只自動整理一次，記在 sessionStorage
const CHECK_INTERVAL = 5 * 60 * 1000
const RELOADED_KEY = 'version_reloaded'

export default defineNuxtPlugin((nuxtApp) => {
  const current = useRuntimeConfig().public.buildNo
  // 開發模式沒有正式的建置編號，比了也沒意義
  if (!current || current === 'dev') return

  let outdatedBuild = ''
  let lastCheck = 0

  async function fetchLatest() {
    try {
      const res = await $fetch(`/version.json?_t=${Date.now()}`, {
        headers: { 'Cache-Control': 'no-cache' }
      })
      return res?.buildNo || ''
    } catch {
      // 讀不到就當作沒換版，檢查失敗不該影響使用
      return ''
    }
  }

  function alreadyReloadedFor(build) {
    try {
      return sessionStorage.getItem(RELOADED_KEY) === build
    } catch {
      return false
    }
  }

  function markReloaded(build) {
    try {
      sessionStorage.setItem(RELOADED_KEY, build)
    } catch {
      // 無痕模式寫不進去：最多就是 CDN 吐舊頁時多整理一次
    }
  }

  function reloadTo(build, url) {
    if (alreadyReloadedFor(build)) return
    markReloaded(build)
    if (url) window.location.assign(url)
    else window.location.reload()
  }

  async function check(reloadNow) {
    lastCheck = Date.now()
    const latest = await fetchLatest()
    if (!latest || latest === current) return
    outdatedBuild = latest
    if (reloadNow) reloadTo(latest)
  }

  nuxtApp.hook('app:mounted', () => {
    check(true)

    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState !== 'visible') return
      // 切回來就查，但不要來回切分頁時每次都打
      if (Date.now() - lastCheck < 30 * 1000) return
      check(true)
    })

    // iOS Safari 的上一頁會從 bfcache 還原整個頁面，連 JS 狀態都是舊的
    window.addEventListener('pageshow', (e) => {
      if (e.persisted) check(true)
    })

    setInterval(() => {
      if (document.visibilityState === 'visible') check(false)
    }, CHECK_INTERVAL)
  })

  // 換頁時發現已經舊了：直接整頁載入目標網址，不再走 SPA 換頁
  useRouter().beforeEach((to, from) => {
    if (!outdatedBuild || to.fullPath === from.fullPath) return
    if (alreadyReloadedFor(outdatedBuild)) return
    reloadTo(outdatedBuild, to.fullPath)
    return false
  })
})
